import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import MissionDetailMissionPlan from '@/components/mission/MissionDetailMissionPlan.vue'
import { buildFleetUIStateId, FleetUiState } from '@/models/ui/FleetUiState'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailMissionPlan',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const showTabs = ref(true)
onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})

const fleet_uiid = computed(() => {
  return buildFleetUIStateId(props.fleet.FLE_ID!, 'detail')
})

// recupere le state de travail
const fleetState = computed(() => {
  // retourne un FleetUiState
  return store.myGetters.fleetUiStateByUiid(fleet_uiid.value)
})

const missions = computed(
  () => props.fleet.activeMissionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

console.log('fleet', props.fleet)

watch(
  selectedGliderIdx,
  () => {
    fleetState.value.selectedMissionPlanMissionId =
      store.myGetters.missionsById[gliders.value?.[selectedGliderIdx.value]?.id!]?.misId || -1
  },
  { immediate: true },
)

return { __sfc: true,props, showTabs, fleet_uiid, fleetState, missions, gliders, selectedGliderIdx, store, MissionDetailMissionPlan }
}

})